import React from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  MenuItem,
  Select,
  Typography,
  withStyles
} from '@material-ui/core';
import { cloneDeep } from 'lodash';
import './CustomSelect.css';
import { injectIntl } from 'react-intl';
import { formatNumber } from '../../../utils/format-number-util';
import { PRICE_PRECISION } from '../../../constants/decimal-points';

const styles = {
  formControl: {
    position: 'relative'
  }
};

class CustomSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      options: this.props.options
    };

    this.handleChangeSelect = this.handleChangeSelect.bind(this);
    this.getLabelText = this.getLabelText.bind(this);
    this.labelForValue = this.labelForValue.bind(this);
    this.setupOptions = this.setupOptions.bind(this);
  }

  componentDidMount() {
    this.setupOptions(this.props.options);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.options !== prevProps.options) {
      this.setupOptions(this.props.options);
    }
  }

  setupOptions(options) {
    const modifiedOptions = cloneDeep(options);

    if (!this.props.disableCustomOption) {
      modifiedOptions.push({
        value: Number.MIN_SAFE_INTEGER,
        label: 'Custom'
      });
    }

    this.setState({
      options: modifiedOptions
    });
  }

  labelForValue(value) {
    const item = this.state.options.find((option) => option.value === value);
    return !!item
      ? item.label
      : !!value
      ? formatNumber(value, PRICE_PRECISION)
      : '';
  }

  handleChangeSelect(value) {
    const isCustomSelected = value === Number.MIN_SAFE_INTEGER;
    if (isCustomSelected) {
      this.props.handleCustomSelected();
    } else {
      this.props.handleChange(value);
    }
  }

  getLabelText(option) {
    const startAdornment = this.props.startAdornment || '';
    switch (option.value) {
      case this.props.originalValue:
        return `${startAdornment}${option.label}`;
      case this.props.selectedValue:
        return `${startAdornment}${
          option.label
        } (${this.props.intl.formatMessage({
          id: 'new'
        })})`;
      case Number.MIN_SAFE_INTEGER:
        return option.label;
      default:
        return `${startAdornment}${option.label}`;
    }
  }

  render() {
    const startAdornment = !!this.props.startAdornment
      ? this.props.startAdornment
      : '';
    const endAdornment = !!this.props.endAdornment
      ? this.props.endAdornment
      : '';

    return (
      <FormControl fullWidth className="custom-select">
        <div className="row">
          <div className="col-xs-12">
            <Typography type="body2" gutterBottom align="left">
              {this.props.labelText}
            </Typography>
          </div>
        </div>
        <div className="value-wrapper">
          {
            <div
              className={`${
                this.props.originalValue !== this.props.selectedValue
                  ? 'changed-initial-textfield'
                  : ''
              }`}
            >
              {`${startAdornment}${this.labelForValue(
                this.props.originalValue
              )}${endAdornment}`}
            </div>
          }
          &nbsp;&nbsp;
          {(this.props.disabled || this.state.isCustomSelected) &&
          this.props.originalValue !== this.props.selectedValue ? (
            <div
              className={`${
                this.props.approvalRequired ? 'adjustment-text' : ''
              }`}
            >
              {`${startAdornment}${this.labelForValue(
                this.props.selectedValue
              )}${endAdornment}`}
            </div>
          ) : null}
        </div>
        {this.props.disabled ? null : (
          <Select
            disabled={this.props.disabled}
            value={this.props.selectedValue}
            onChange={(event) => this.handleChangeSelect(event.target.value)}
          >
            {this.state.options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                <Typography type="title">
                  {this.getLabelText(option)}
                </Typography>
              </MenuItem>
            ))}
          </Select>
        )}
      </FormControl>
    );
  }
}

CustomSelect.propTypes = {
  selectedValue: PropTypes.any.isRequired,
  originalValue: PropTypes.any.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.number])
  ),
  labelText: PropTypes.string.isRequired,
  approvalRequired: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  handleCustomSelected: PropTypes.func,
  startAdornment: PropTypes.string,
  endAdornment: PropTypes.string,
  disabled: PropTypes.bool,
  disableCustomOption: PropTypes.bool
};

export default injectIntl(withStyles(styles)(CustomSelect));
